import { type AddressFormSchema } from './address-form-schema';
import { type AddressQuerySchema } from './address-query-schema';
import { defaultAddressValues } from './model';

export const hasAddress = (address: AddressQuerySchema | undefined): boolean => {
  if (!address) {
    return false;
  }
  if (address.id === defaultAddressValues.id) {
    return false;
  }
  let hasValue = false;
  Object.keys(address).forEach((key) => {
    const value = address[key as keyof AddressQuerySchema];
    if (value && typeof value === 'object') {
      if (Object.values(value).filter(Boolean).length > 0) {
        hasValue = true;
      }
    } else if (value) {
      hasValue = true;
    }
  });

  return hasValue;
};

export const isValidPostalCode = ({ state }: Pick<Partial<AddressQuerySchema>, 'state'>): boolean => {
  return !!state?.id;
};

export const addressQueryToFormValue = (address: AddressQuerySchema | undefined | null): AddressFormSchema => {
  if (!address) {
    return { ...defaultAddressValues };
  }
  return {
    is_valid_postal_code: isValidPostalCode({ state: address.state }),
    id: address.id,
    address1: address.address1 ?? '',
    address2: address.address2 ?? '',
    country: address.country,
    state: address.state ?? null,
    city: address.city ? { name: address.city ?? '', value: address.city ?? '' } : null,
    postal_code: address.postal_code ?? '',
    region: address.region ?? '',
    validation_action: null,
    validation_decision: 'pending',
  };
};

export const cityNameToFormValue = (city: string): AddressFormSchema['city'] => ({ name: city, value: city });
export const stateNameToFormValue = (state: string): AddressFormSchema['state'] => ({
  name: state,
  id: 99999,
  abbreviation: '',
  country_id: 99999,
});
export const countryNameToFormValue = (country: string): AddressFormSchema['country'] => ({
  name: country,
  id: 99999,
  abbreviation: '',
  short_name: null,
  capital_city: null,
  continent_abbreviation: null,
  continent_name: null,
});

export const shouldFetchPostalCodeData = (
  { country }: { country: AddressFormSchema['country'] | null },
  postalCode: string
): boolean => {
  const shouldCall =
    postalCode.length > 0 &&
    (!country ||
      country.id === -1 ||
      (!!country && country.id > -1 && !!country.short_name && country.short_name.toLowerCase() === 'us'));
  // console.log('shouldFetchPostalCodeData', { country, postalCode, shouldCall });

  return shouldCall;
};

export const showFieldsAsInputs = ({
  is_valid_postal_code,
  country,
}: Pick<AddressFormSchema, 'is_valid_postal_code' | 'country'>): boolean => {
  return country?.short_name?.toLowerCase() !== 'us' && !is_valid_postal_code;
};
